import React, { useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import styles from "./HomeNew.module.css";
import home_images from "../../assets/images/AI Home.jpg";

const OurMission = () => {
  return (
    <Box className={styles.employer_details}>
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <Box>
          <img
            src={home_images}
            alt=""
            width="100%"
            // height="120px"
            style={{ marginTop: "20px" }}
          />
        </Box>
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        style={{ padding: "10px 10px 55px 20px", backgroundColor: "#f2f6f7" }}
      >
        <Box>
          <Typography sx={{ fontSize: "20px !important" }}>
            <b>Our Mission</b>
          </Typography>
          <Typography sx={{ fontSize: "16px !important", marginTop: "10px" }}>
            Our mission is to revolutionize the way companies manage their
            hiring processes by providing a robust, intuitive, and scalable ATS.
            We aim to reduce administrative burdens, improve the recruitment
            experience, and enhance recruitment efficiency, allowing you to
            focus on what truly matters – building your team.
          </Typography>
        </Box>
      </Grid>
    </Box>
  );
};

export default OurMission;
